export const enumContextEtudiantThumbnail = {
    RECRUTEMENTBOARD : "recrutement-board"
}